import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';
import { FormControl, Input, InputLabel, NativeSelect, TextField } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing(1),
    width: '97%',
    minWidth: 120,
  },
  nselect: {
    paddingLeft: 0,
  },
});

const CountrySelectQuery = graphql`
query CountrySelectQuery($first: Int) {
  allIsoCountryTs(condition: {active: 1} orderBy:COUNTRY_ASC first: $first) {
    totalCount
    nodes {
      countryCode2
      country
      regionLabel
    }
  }
}
`;

class CountrySelect extends Component {

  setCountryCodeState = (aValue) => {
    this.props.setCountryCodeState(aValue);
  };


  render() {
    const classes = this.props.classes;
    let maxCountries = 300;
    let countryCode = this.props.countryCode;
    if (countryCode == null) {
      countryCode = "";
    }

    let widthOverride = null;
    if (this.props.widthOverride != null) {
      widthOverride = this.props.widthOverride;
    }

    let label = 'Country';
    if (this.props.overrideLabel) {
      label = this.props.overrideLabel;
    }
    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={CountrySelectQuery}
        variables={{first: maxCountries}}
        render={({error, props})=> {
          if (error) {
            if (!this.props.displayOnly) {
              return (
                <FormControl variant="standard"
                  className={classes.formControl}
                  style={
                    widthOverride == null
                    ? {
                        'width': '97%'
                      }
                    : {
                        'width': widthOverride
                      }
                  }
                >
                  <InputLabel shrink htmlFor="country">{label}{this.props.showRequired ? ' *' : ''}</InputLabel>
                  <NativeSelect
                    value={countryCode}
                    input={<Input name="country" id="country" />}
                    className={classes.nselect}
                  >
                    <option key="" value="">Loading...</option>
                  </NativeSelect>
                </FormControl>
              );
            } else {
              return (
                <TextField  data-recording-ignore="mask" className={classes.formControl}
                  id="country" label={this.props.showRequired ?  label + ' *' : label} 
                  value={"Loading...."}
                  InputProps={{ readOnly: true, disableUnderline: true }}                 
                />
              );
            }
          } else if (props) {
            // Options from result of query

            if (!this.props.displayOnly) {
              //not display only
              return (
                <FormControl variant="standard"
                  className={classes.formControl}
                  style={
                    widthOverride == null
                    ? {
                        'width': '97%'
                      }
                    : {
                        'width': widthOverride
                      }
                  }
                >
                  <InputLabel shrink htmlFor="country">{label}{this.props.showRequired ? ' *' : ''}</InputLabel>
                  <NativeSelect
                    value={countryCode}
                    input={<Input name="country" id="country" />}
                    onChange={(e) => this.setCountryCodeState(e.target.value)}
                    className={classes.nselect}
                  >
                    <option key="" value="">Select a country</option>
                    {props.allIsoCountryTs.nodes.map(n => {
                      return(<option key={n.countryCode2} value={n.countryCode2}>{n.country}</option>);
                    })}
                  </NativeSelect>
                </FormControl>
              );
            } else {
              //display only gets a text field with country decoded
              let countryName = countryCode;
              for (var i = 0; i < props.allIsoCountryTs.nodes.length; i++) {
                let countryNode = props.allIsoCountryTs.nodes[i]
                if (countryNode.countryCode2 === countryCode) {
                  countryName = countryNode.country;
                  break;
                }
              }

              return (
                <TextField  data-recording-ignore="mask" className={classes.formControl}
                    id="country" label={this.props.showRequired ? label + ' *' : label} 
                    value={countryName}
                    InputProps={{ readOnly: true, disableUnderline: true }}                 
                  />
              );
            }
          }

          //no query results yet
          if (!this.props.displayOnly) {
            return (
              <FormControl variant="standard"
                className={classes.formControl}
                style={
                  widthOverride == null
                  ? {
                      'width': '97%'
                    }
                  : {
                      'width': widthOverride
                    }
                }
              >
                <InputLabel shrink htmlFor="country">{label}{this.props.showRequired ? ' *' : ''}</InputLabel>
                <NativeSelect
                  value={countryCode}
                  input={<Input name="country" id="country" />}
                  className={classes.nselect}
                >
                  <option key="" value="">Loading...</option>
                </NativeSelect>
              </FormControl>
            );
          } else {
            return (
              <TextField  data-recording-ignore="mask" className={classes.formControl}
                  id="country" label={this.props.showRequired ? label + ' *' : label} 
                  value={"Loading...."}
                  InputProps={{ readOnly: true, disableUnderline: true }}                 
                />
            );
          }


        }}
      />
    );
  }
    
}

export default withStyles(styleSheet)(CountrySelect);
